export default __webpack_public_path__ + "static/media/sagnik - 420_SAGNIK GHOSH.9127a88e.png";